import { authUsuarioComputed } from "@/state/helpers";
import { mapActions, mapGetters } from "vuex";
import config from "@/config";
import {
  normalizeDocumentEmail,
  hasDocumentPermission,
} from "@/helpers/common";
export default {
    computed: {
        ...authUsuarioComputed,
        ...mapGetters({
            userRestrictedDocuments: "document/userRestrictedDocuments",
        }),
        userAuthIsInListUserRestrictedDocuments(){
            if(!this.user || !this.user.email) return false;

            const alloweEmails = this.userRestrictedDocuments.items.map(item => item.email);
            return hasDocumentPermission(this.user.email, alloweEmails);
           
        },
    },
    methods: {
        ...mapActions({
            getUserRestrictedDocuments: "document/getUserRestrictedDocuments",
        }),
        async getUserRestrictedDocumentsData(user){
            if(!this.userRestrictedDocuments.items.length && user){
                let self = this;
                await self.getUserRestrictedDocuments({
                    password: config.password_manteiners,
                    page: 0,
                    filter: normalizeDocumentEmail(user),
                    document_viewer: true
                });
            }
        },
    },
    watch: {
        "user": {
            immediate: true,
            handler(user){
                if(user){
                    this.getUserRestrictedDocumentsData(user.email)
                }
            }
        } 
    }
}